export default __webpack_public_path__ + "static/media/8154ce990188fdb5f3a8c9be75b94491.270d8038.png";